import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectSidebarState } from '@brands/store/selectors/sidebarState';
import React, { useEffect, useRef, useState } from 'react';

import downArrow from './downArrow.svg';
import emergency from './emergencyIcon.svg';
import leftArrow from './leftArrowIcon.svg';
import styles from './styles.module.scss';

const PatientERSection = (): JSX.Element => {
  const { isCollapsed } = useAppSelector(selectSidebarState);
  const [expandERSection, setExpandERSection] = useState(false);
  const erSectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (expandERSection && erSectionRef.current) {
      erSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [expandERSection]);

  return (
    <div className={styles.patientERSectionFullWidth}>
      <div className={`${styles.patientERSectionParent} ${!isCollapsed && styles.patientERSectionParentExpanded}`}>
        <div
          className={`fs-unmask ${styles.patientERSection} ${expandERSection && styles.patientERSectionExpanded}`}
          style={{ cursor: 'pointer' }}
          onClick={() => setExpandERSection((prev) => !prev)}
        >
          <div className={styles.patientERSectionLeft}>
            <img src={emergency} />
            <span className="fs-unmask">Should I go to the emergency room?</span>
          </div>
          <div className={`fs-unmask ${styles.patientERSectionRight}`}>
            {!expandERSection ? <img src={leftArrow} /> : <img src={downArrow} />}
          </div>
        </div>
        {expandERSection && (
          <div className={`fs-unmask ${styles.patientERSectionText}`}>
            <p className={styles.patientERSectionP} ref={erSectionRef}>
              Although dental emergencies are rare, there are a few life-threatening situations that require immediate
              supervision. If you experience any of the below, please call 911 or go to your nearest emergency
              department:
            </p>
            <ul className={styles.patientERList}>
              <li className={styles.patientERSectionP}>• Difficulty breathing</li>
              <li className={styles.patientERSectionP}>
                • Intense pain in your left arm that is spreading to your neck and/or jaw
              </li>
              <li className={styles.patientERSectionP}>• Intense pain behind the eyes and/or double vision</li>
              <li className={styles.patientERSectionP}>
                • Swelling/pressure that is preventing you from swallowing your spit
              </li>
              <li className={styles.patientERSectionP}>• Swelling/pressure behind the tongue moving it out of place</li>
              <li className={styles.patientERSectionP}>
                • Swelling/pressure from your mouth preventing you from opening your mouth
              </li>
              <li className={styles.patientERSectionP}>• Swelling from your mouth to your upper eyelid</li>
              <li className={styles.patientERSectionP}>• Fever or vomiting possibly caused by a dental infection</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
export default PatientERSection;
